import { useEffect, useRef, useState, useCallback } from 'react';
import { useAuth } from '@/context/AuthContext';
import { subscribeReport } from './reportRequests';
export const useReport = query => {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [revision, setRevision] = useState(0);
  const refresh = useCallback(() => setRevision(v => v + 1), []);
  const serial = useRef(0);
  useEffect(() => {
    const generation = ++serial.current;
    setLoading(true); setError('');
    let subscription;
    const timer = setTimeout(() => {
      subscription = subscribeReport(`/reporting?${query}`, user?.user_id);
      subscription.promise.then(r => { if (serial.current === generation) setData(r.data); }).catch(() => { if (serial.current === generation) { setData(null); setError('Report unavailable. Your filters are preserved.'); } }).finally(() => { if (serial.current === generation) setLoading(false); });
    }, 80);
    return () => { serial.current++; clearTimeout(timer); subscription?.release(); };
  }, [query, revision, user?.user_id]);
  return { data, error, loading, refresh };
};